import React, {Component} from 'react'

import {Form, FormGroup, InputGroup, Button, Glyphicon} from 'react-bootstrap'
import {Typeahead} from 'react-bootstrap-typeahead-ali/dist/react-bootstrap-typeahead'
import {Actions} from 'jumpstate'
import showToastr from '../../../utils/showToastr'

import './Layout/SearchBox.css'

class SearchComponent extends Component {
  constructor (props, refs) {
    super(props, refs)

    const query = this.context.router.location.query
    this.state = {
      term: (query.q === undefined || query.q === '') ? '' : query.q,
      options: [],
      message: '',
      isLoading: false
    }
    this.timeout = null
    this.doSearch = this.doSearch.bind(this)
    this.changeKeyword = this.changeKeyword.bind(this)
    this.keyHandler = this.keyHandler.bind(this)
  }

  doSearch () {
    this.setState({isLoading: true})
    if (this.state.term === '') { return showToastr('error', 'جستجو', 'برای جستجو لازم است چند حرف وارد نمایید') }
    this.props.onResult(this.state.term)
  }

  keyHandler (event) {
    if (event.keyCode === 13) {
      this.doSearch()
    }
  }

  changeKeyword (keyword) {
    this.setState({message: keyword, term: keyword})
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    if (keyword.length > 0) {
      this.timeout = setTimeout(() => {
        Actions.autocompleteHorse(keyword).then((res) => {
          Actions.setHorseResult({term: keyword, result: res.data})
          if (res.data.length === 0) {
            this.setState({options: [], message: 'موردی یافت نشد'})
          } else {
            this.setState({options: res.data, message: ''})
          }
        })
      }, 700)
    } else {
      this.setState({message: '', options: []})
    }
  }

  render () {
    const { options, message, isLoading } = this.state
    const submitSearch = (e) => {
      e.preventDefault()
      this.doSearch()
    }
    const pickOption = (options) => {
      this.setState({term: options[0]}, this.doSearch)
    }
    return (
      <Form onSubmit={submitSearch} disable={isLoading} className="container searchbox">
        <FormGroup controlId="formInlineEmail">
          <InputGroup onKeyUp={this.keyHandler} className="add-on">
            <Typeahead
              onChange={pickOption}
              onInputChange={this.changeKeyword}
              emptyLabel={message}
              placeholder="کلمه مورد نظر را وارد نمایید."
              options={options}
              defaultText={this.state.term}
            />
            <InputGroup.Button>
              <Button className="searchButton" type="submit">
                <Glyphicon glyph="search" />
              </Button>
            </InputGroup.Button>
          </InputGroup>
        </FormGroup>
      </Form>
    )
  }
}

SearchComponent.propTypes = {
  onResult: React.PropTypes.func
}

SearchComponent.contextTypes = {
  router: React.PropTypes.object
}

export default SearchComponent



// WEBPACK FOOTER //
// ./src/components/Common/SearchBox/SearchComponent.js